import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;
const FINGERPRINT_KEY = 'device_fingerprint_cache';

// Initialize fingerprint
export const initFingerprint = async () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
};

// Get device fingerprint - uses cached value for consistency across sessions
export const getDeviceFingerprint = async () => {
  // Check for cached fingerprint first (ensures consistency across sessions)
  const cached = localStorage.getItem(FINGERPRINT_KEY);
  if (cached) {
    try {
      const parsedCache = JSON.parse(cached);
      // Use cached fingerprint if it exists and is not too old (6 months)
      const cacheAge = Date.now() - (parsedCache.timestamp || 0);
      const maxAge = 180 * 24 * 60 * 60 * 1000; // 6 months (180 days)
      if (parsedCache.fingerprint && cacheAge < maxAge) {
        return {
          fingerprint: parsedCache.fingerprint,
          deviceName: getDeviceName(),
          deviceInfo: {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            language: navigator.language,
            screenResolution: `${window.screen.width}x${window.screen.height}`,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            vendor: navigator.vendor,
            browserName: getBrowserName(),
            osName: getOSName()
          }
        };
      }
    } catch (e) {
      console.warn('Error parsing cached fingerprint:', e);
    }
  }

  // Generate new fingerprint
  const fp = await initFingerprint();
  const result = await fp.get();
  
  // Cache the fingerprint for consistency (using localStorage for persistence)
  const cacheData = {
    fingerprint: result.visitorId,
    timestamp: Date.now()
  };
  localStorage.setItem(FINGERPRINT_KEY, JSON.stringify(cacheData));
  
  return {
    fingerprint: result.visitorId,
    deviceName: getDeviceName(),
    deviceInfo: {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      vendor: navigator.vendor,
      browserName: getBrowserName(),
      osName: getOSName()
    }
  };
};

// Get browser name
const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes('Firefox')) return 'Firefox';
  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) return 'Chrome';
  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
  if (userAgent.includes('Edg')) return 'Edge';
  if (userAgent.includes('Opera') || userAgent.includes('OPR')) return 'Opera';
  return 'Unknown';
};

// Get OS name
const getOSName = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes('Windows')) return 'Windows';
  if (userAgent.includes('Mac')) return 'macOS';
  if (userAgent.includes('Linux')) return 'Linux';
  if (userAgent.includes('Android')) return 'Android';
  if (userAgent.includes('iOS') || userAgent.includes('iPhone') || userAgent.includes('iPad')) return 'iOS';
  return 'Unknown';
};

// Get device name (user-friendly)
const getDeviceName = () => {
  const browser = getBrowserName();
  const os = getOSName();
  return `${browser} en ${os}`;
};
